module.exports = __webpack_public_path__ + "static/media/tr.d4a61f6a.svg";